import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { addMaterialItam } from "api";
import { withTranslation } from "react-i18next";

class AddMaterialItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      item: null,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    values.comsumptionType = parseInt(values.comsumptionType);
    delete values.createdAt;
    delete values.updatedAt;
    const data = await addMaterialItam(values);
    if (data.data && data.success) {
      this.setState({ item: data.data });
      JSON.stringify(data.data);
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Add Item" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div>
                      <h4 className="text-black fw-bold mb-4">Add Item</h4>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.item != null
                          ? {
                              id: this.state.item.id,
                              name: this.state.item.name,
                              comsumptionType: this.state.item.comsumptionType,
                            }
                          : {
                              id: "",
                              name: "",
                              comsumptionType: "",
                            }
                      }
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        id: Yup.string().required("This value is Required"),
                        name: Yup.string().min(1).max(100).required("This value is Required"),
                        comsumptionType: Yup.string().min(1).max(255).required(
                          "This value is Required"
                        ),
                      })}
                      onSubmit={async (values, formikHelpers) => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Item ID
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  type="text"
                                  name="id"
                                  placeholder=""
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Item Name')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="comsumptionType"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Comsumption Type
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.comsumptionType &&
                                    touched.comsumptionType
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="comsumptionType"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="1">1 Time </option>
                                  <option value="2">2 Time </option>
                                  <option value="3">3 Time </option>
                                  <option value="4">Multiple Time</option>
                                </Field>
                                <ErrorMessage
                                  name="comsumptionType"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => this.handleSubmit(event, values)}
                              >
                                Submit
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AddMaterialItem);